<template>
  <div>
    <v-menu
      ref="menu1"
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="dateFormatted"
          :label="label"
          :hint="texto"
          persistent-hint
          @blur="date = parseDate(dateFormatted)"
          v-on="on"
          readonly
          append-icon="mdi-close"
          prepend-inner-icon="mdi-calendar"
          @click:prepend-inner="[(menu1 = true)]"
          @click:append="[$emit('dateValue', null), (date = null)]"
          class="title"
        ></v-text-field>
      </template>
      <v-date-picker
        :min="Dinicial"
        v-model="date"
        locale="pt-br"
        @input="[(menu1 = false), $emit('dateValue', date)]"
        :type="type"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "calendar",
  props: ["label", "texto", "Dinicial", "type"],
  data() {
    return {
      date: null,
      current_date: new Date().toISOString().substr(0, 10),
      dateFormatted: "",
      menu1: false,
    };
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  created() {
    this.dateFormatted = this.formatDate(this.date);
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.type == "month") {
        return `${month}/${year}`;
      }
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
